import React from 'react'
import { useRoutes } from 'react-router-dom'

import { Role, Routes } from '../../../../shared/enum'
import { RootRouter } from '../../../../shared/UI/RootRouter'
import { Root, Id, UserTask } from './pages'

export const TaskController = () => {
  return useRoutes([
    { path: Routes.ROOT, element: <Root /> },
    { path: Routes.USER, element: <RootRouter role={Role.ADMIN} component={<UserTask />} /> },
    { path: Routes.ID, element: <Id /> },
  ])
}
